import { render, staticRenderFns } from "./project.vue?vue&type=template&id=5b54ed66&scoped=true&"
import script from "./project.vue?vue&type=script&lang=js&"
export * from "./project.vue?vue&type=script&lang=js&"
import style0 from "./project.vue?vue&type=style&index=0&id=5b54ed66&prod&lang=less&scoped=true&"
import style1 from "./project.vue?vue&type=style&index=1&id=5b54ed66&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b54ed66",
  null
  
)

export default component.exports